import { IncomingMessage } from 'http';

import { QueryFunction, QueryKey } from '@tanstack/react-query';

import fetchProductUniqueVehicle from '../../../services/products/fetch-unique-vehicle';

const getProductUniqueVehicle = (
  options: {
    locale: string;
    slug: string;
    shipping_location?: string;
    detailed_prices?: boolean;
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchProductUniqueVehicle>>] => [
  [
    'user-dependent',
    'unique-vehicle-product',
    {
      locale: options.locale,
      slug: options.slug,
      detailed_prices: options.detailed_prices,
    },
  ],
  ({
    queryKey: [, , key],
  }: {
    queryKey: [
      string,
      string,
      {
        locale: string;
        slug: string;
        detailed_prices?: boolean;
      }
    ];
  }) => fetchProductUniqueVehicle(options, req),
];

export default getProductUniqueVehicle;
